import Icon from '@material-ui/core/Icon';
import * as React from 'react';
import { Button } from '~frontend-common/components/buttons';
import { Box } from '~frontend-common/components/ui';

interface Props {
  buttonText: string;
  disabled?: boolean;
  goBack?: () => void;
  hideArrow?: boolean;
  isBackAllowed?: boolean;
  loading?: boolean;
}

export const BackButton: React.SFC<Props> = ({
  goBack,
  buttonText,
  isBackAllowed = true,
  disabled = false,
  hideArrow = false,
}) => {
  if (!isBackAllowed) {
    return <div />;
  }

  return (
    <Box justify="flex-start" width={['100%']}>
      <Button
        style={{ backgroundColor: 'transparent' }}
        color="default"
        size="large"
        onClick={goBack}
        disabled={disabled}
      >
        {!hideArrow && <Icon>chevron_left</Icon>}
        {buttonText}
      </Button>
    </Box>
  );
};
